import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 dílů', '5 bonusů', '240 stran', '1.–9. ročník'];
const reassurances = ['Okamžité digitální stažení', 'PDF připravené k tisku', '7denní garance spokojenosti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsormn3uimq">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk9e684mx9p" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7ldi5irk5j">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1n0u1zlo35x">
          Vaše hodiny pracovních činností mohou být <em className="text-red-700" data-id="element-118" data-mp="223mjeyq9jfaz">připravené už dnes.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221ju6gwxpq7b">
          Místo hledání nápadů na internetu, kreslení každé šablony a nedělních večerů nad přípravami máte přehledný balíček pracovních činností na celý školní rok. Víc času na to, na čem opravdu záleží:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s6il3at4bam2">
          Vaši žáci. Vaše výuka. Váš život mimo školu.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="123mwcflfdlo3">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="162mb0rwykwsq">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b2i43w44b3ti">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fvl34jrnz5h3">Jednorázová platba – žádné předplatné.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ks1pp9j7tbs2">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1psfumipis5lv" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1puaj27002fup">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3quoyqyyrj1qz">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qux7qfrrlmww" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}